// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMemberSetRoleBody = {
  poolId: string;
  targetUserId: string;
  poolRole: "admin" | "member";
};

export type typeMemberSetRoleOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { targetUserId: string; poolRole: "admin" | "member" };
};

export type typeMemberSetRoleOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberSetRoleOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberSetRoleOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMemberSetRoleBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
    poolRole: { type: "string", enum: ["admin", "member"] },
  },
  required: ["poolId", "targetUserId", "poolRole"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMemberSetRole(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMemberSetRoleBody);
  }

  return async function postMemberSetRole(
    payload: typeMemberSetRoleBody,
  ): Promise<typeMemberSetRoleOutput200 | typeMemberSetRoleOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMemberSetRole" failed before calling the network. #35e430995ec4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#35e430995ec4" },
        },
        data: null,
      } as typeMemberSetRoleOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/member/set-role`,
      httpMethod: "POST",
      options,
    })) as typeMemberSetRoleOutput200 | typeMemberSetRoleOutput400;
  };
}
